import vue from "vue";
import axios from "axios";
import qs from "qs";
import router from "../router";
import store from "../store";
import { Toast, Dialog } from "vant";
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain=true;
axios.defaults.time = 18000;
// axios.defaults.baseURL ='http://devadmin.vascularnews.cn';
var ishttps = "https:" == document.location.protocol ? true : false;
if (ishttps) {
  axios.defaults.baseURL = "https://medmeeting.talkmed.com";
} else {
  axios.defaults.baseURL = "https://xgzx.admin.talkmed.com";
}

export const baseURL = axios.defaults.baseURL;
export const webURL = "https://xgzx.talkmed.com";
//拦截器   在请求前    对数据做处理

axios.interceptors.request.use(
  config => {
    if (common.is_weixin()) {
      //微信端页面
      config.headers["platform"] = "wechat";
    } else {
      //pc端页面
      config.headers["platform"] = "web";
    }
    if (localStorage.getItem("token")) {
      config.headers["token"] = localStorage.getItem("token");
    }
    if (config.method == "post" && config.data.constructor == FormData) {
      return config;
    } else {
      config.data = qs.stringify(config.data);
      return config;
    }
  },
  error => {}
);
axios.interceptors.response.use(
  response => {
    let code = response.data.code;
    if (code && typeof code != "undefined") {
      if (code == 602) {
        if (common.is_weixin()) {
          // 微信端未授权：展示提示后跳转，避免整页 display:none 造成纯白屏
          Toast.loading({
            message: "授权中...",
            forbidClick: true,
            duration: 0
          });
          common.wxAuth();
        } else {
          let path = window.location.href;
          Toast.fail("账号信息已过期，请重新登录", 2000);
          var callback_url = window.location.href;
          if (path.indexOf("/collection/") > -1) {
            window.location.href =
              "/collection/login?url=" + encodeURIComponent(callback_url);
          } else {
            window.location.href =
              "/vascularNews/user/login?url=" +
              encodeURIComponent(callback_url);
          }
        }
      } else if (code == 603) {
        //未绑定
        // var callback_url=window.location.href;
        // window.location.href='/user/bindMobile?callback_url='+callback_url;
      } else if (code != 602 || code != 603 || code != 0) {
        Toast({
          message: response.data.error_msg,
          duration: 2000
        });
      }
    }
    return response;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "错误请求";
          Toast.fail(err.message);
          break;
        case 403:
          err.message = "拒绝访问";
          Toast.fail(err.message);
          break;
        case 404:
          err.message = "请求错误,未找到该资源";
          Toast.fail(err.message);
          break;
        case 405:
          err.message = "请求方法未允许";
          Toast.fail(err.message);
          break;
        case 408:
          err.message = "请求超时";
          Toast.fail(err.message);
          break;
        case 502:
          err.message = "网络错误";
          Toast.fail(err.message);
          break;
        case 413:
          err.message = "视频上传失败";
          Toast.fail(err.message);
          break;
        default:
          Toast.fail(err.response.statusText);
    
      }
    } else {
      // err.message = '连接服务器失败';
      // common.toast(JSON.stringify(err),1000,'cross')
    }
    NProgress.done();
    // 网络断开时 err.response 可能为 undefined，避免后续读 .data 抛错导致白屏
    return Promise.resolve(
      err.response || {
        data: {
          code: -1,
          error_msg: (err && err.message) || "网络异常，请稍后重试"
        }
      }
    );
  }
);

export function fetch(url, params, method, loading, config) {
  return new Promise((resolve, reject) => {
    // if(localStorage.getItem('token')){
    //     params.token=localStorage.getItem('token');
    // }
    // var fun = method=='POST'?axios.post(url,params):axios.get(url,{params:params});
    let fun = null;
    switch (method) {
      case "POST":
        fun = axios.post(url, params);
        break;
      case "GET":
        fun = axios.get(url, { params: params });
        break;
      case "DELETE":
        fun = axios.delete(url, { params: params });
        break;
      case "PUT":
        fun = axios.put(url, params);
        break;
      default:
        fun = axios.get(url, { params: params });
    }
    // let fun=null;
    // if(method=='POST'){
    //   fun=axios.post(url,params);

    // }
    // if(method=='GET'){
    //   fun=axios.get(url,{params:params});

    // }
    // if(method=="DELETE"){
    //   fun=axios.delete(url,{params:params})

    // }
    // if(method=='PUT'){
    //   fun=axios.put(url,params)
    // }
    fun.then(
      response => {
        if (!response) {
          resolve({ code: -1, error_msg: "网络异常，请稍后重试" });
          return;
        }
        resolve(config ? response : response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/config/fetch.js